import React, { useEffect, useContext } from 'react';
import {
  params, string as StringType, arrayOf as ArrayType, useDataModel, shape as ShapeType
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Carousel } from '@one-thd/sui-carousel';
import {
  Card,
  CardMedia,
  Typography
} from '@one-thd/sui-atomic-components';

export const SavingsByDepartment = () => {

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('savings-by-department.ready');
  }, []);

  const { data } = useDataModel('savingsDepartment');
  const departmentCategories = data?.savingsDepartment?.departmentCategories;
  if (!departmentCategories?.length) return null;

  // eslint-disable-next-line max-len
  const containerStyles = 'sm:sui-justify-start sm:sui-items-end lg:sui-items-center sui-flex sui-flex-wrap sui-justify-center sui-mb-3';
  return (
    <div data-component="SavingsByDepartment">
      <div className="sui-paper sui-p-4 sui-pb-1 sui-mb-4">
        <div className={containerStyles}>
          <Typography variant={isMobile ? 'h3' : 'h2'}>Savings by Department</Typography>
        </div>
        <Carousel>
          {departmentCategories.map(({ name, image, url }) => (
            <Card href={url} CardActionAreaProps={{ target: '_blank' }} key={`card-${name}`}>
              <CardMedia src={image?.url} aspect="square" alt={`${name} product`} />
              <Typography align="center" underline="none" variant="body-small">{name}</Typography>
            </Card>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

const displayName = 'SavingsByDepartment';

const propTypes = {};

const defaultProps = {};

SavingsByDepartment.displayName = displayName;
SavingsByDepartment.propTypes = propTypes;
SavingsByDepartment.defaultProps = defaultProps;

SavingsByDepartment.dataModel = {
  savingsDepartment: params({}).shape({
    departmentCategories: ArrayType(ShapeType({
      url: StringType(),
      name: StringType(),
      image: ShapeType({
        url: StringType()
      })
    }))
  })
};
